(function () {
    "use strict";

    // @ngInject
    function AuthServiceCtor($state, AppStates, AppConfigService, AnalyticsService, UsersManager, WebPNService) {
        this.$state = $state;
        this.AppStates = AppStates;
        this.AppConfigService = AppConfigService;
        this.AnalyticsService = AnalyticsService;
        this.UsersManager = UsersManager;
        this.WebPNService = WebPNService;
    }

    Services.AuthService = Class(function () {

        return {

            constructor: AuthServiceCtor,

            logout: function logout() {
                this.UsersManager.logout().then(function afterLogout() {
                    this.WebPNService.unsubscribe();
                    this.AnalyticsService.unidentify();
                    this.$state.go(this.AppStates.root_core_login);
                }.bind(this));
            }
        };
    });
}());
